// extracted by mini-css-extract-plugin
module.exports = {"App":"App__App__1o-Fp","App-logo-spin":"App__App-logo-spin__RvI1J"};